package info.rezident.app.ui.components.widgets

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.AlignItems
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.JustifyContent
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.toModifier
import info.rezident.app.ui.theme.AppTheme
import org.jetbrains.compose.web.css.*

/**
 * A circular component that displays a number with a colored background.
 * The color transitions from medium green (rank 1) to yellow (rank 5).
 *
 * @param number The number to display in the circle
 * @param modifier Additional modifiers to apply
 * @param size The size of the circle (default: 48.px)
 * @param backgroundColor
 */
@Composable
fun NumberCircle(
    number: Int,
    modifier: Modifier = Modifier,
    size: CSSSizeValue<CSSUnit.px> = 48.px,
    backgroundColor: CSSColorValue = AppTheme.colors.icon
) {
    Box(
        modifier
            .size(size)
            .backgroundColor(backgroundColor)
            .borderRadius(50.percent)
            .display(DisplayStyle.Flex)
            .alignItems(AlignItems.Center)
            .justifyContent(JustifyContent.Center),
        contentAlignment = Alignment.Center
    ) {
        SpanText(
            number.toString(),
            AppTheme.typography.h2.toModifier()
                .color(AppTheme.colors.surface)
                .fontWeight(FontWeight.Bold)
        )
    }
}
